var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow63(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_38590)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1322_38590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13V48H48V13H12Z",
    fill: "#08080B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.373 13.3613V47.6372H47.6282V13.3613H12.373Z",
    fill: "#AAAAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7375 14.5076L13.4893 16.2576V21.6886V39.5507V44.3783L13.5513 46.3093L15.3513 46.5507H20.9375H39.3099H44.2755L46.2617 46.4904L46.5099 44.7404V39.3093V21.4473V16.6197L46.4479 14.6886L44.6479 14.4473H39.0617H20.6893H15.7237L13.7375 14.5076Z",
    fill: "#9898E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8623 14.5684V14.689H36.5795L34.8416 14.5684H30.4968H13.8623Z",
    fill: "#8181C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5791 14.5684V14.689H46.1377L43.5308 14.5684H36.5791Z",
    fill: "#7F7FBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8831 14.7498L13.7383 15.655V18.4308V29.8963V41.8446V44.9826L13.8004 46.1693L15.6004 46.3101H21.0624H39.559H44.4004L46.1176 46.2498L46.2624 45.3446V42.5688V31.1032V19.155V16.017L46.2004 14.8303L44.4004 14.6895H38.9383H20.4417H15.6004L13.8831 14.7498Z",
    fill: "#48486C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6143 14.8105V32.3105H13.7384V19.5174V16.1381L13.6143 14.8105Z",
    fill: "#8181C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8623 14.8105V46.1899H46.1382V14.8105H13.8623Z",
    fill: "#161620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2617 14.8105V46.1899H46.3859V23.1381V17.1037L46.2617 14.8105Z",
    fill: "#7F7FBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6074 15.5352V15.7765L14.8557 15.5352H14.6074Z",
    fill: "#25272F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 15.5352V15.6558H21.4337L19.5716 15.5352H14.9785Z",
    fill: "#3C423A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5591 15.5352L21.6833 15.8972H21.8074V15.5352H21.5591ZM22.5522 15.5352L22.4281 18.7938C21.1048 18.9408 22.1879 21.3604 21.7454 22.1731C21.4311 22.7502 20.3819 22.5352 19.8212 22.5352V23.1386H15.9729C15.4682 23.1386 14.7861 22.9637 14.6074 23.5007H14.7316L16.2212 23.2593H20.0695L21.6419 23.4001L21.8074 25.4317L22.4281 30.1386H22.5522L22.4281 25.1903L22.6143 23.4001L24.4143 23.1386L29.6281 23.2593V28.4489C31.4218 27.8864 29.7087 24.6972 30.435 23.5007C30.6938 23.0742 31.6763 23.2593 32.1109 23.2593H37.3247V23.1386H30.7454V22.4145L29.6281 21.2076C29.6281 23.2752 26.4087 22.5352 24.7867 22.5352C24.2666 22.5352 22.935 22.7674 22.6143 22.2737C22.3788 21.9111 22.5522 21.0261 22.5522 20.6041V16.9834C22.5522 16.5683 22.6864 15.854 22.5522 15.5352Z",
    fill: "#25272F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7998 15.5352V15.6558H29.3791L27.517 15.5352H22.7998Z",
    fill: "#314139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3789 15.5352L29.6272 15.7765V15.5352H29.3789Z",
    fill: "#25272F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.373 15.8957H30.4972L30.7455 15.6543L30.373 15.8957Z",
    fill: "#362B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7451 15.5352V15.6558H37.0762L35.3382 15.5352H30.7451Z",
    fill: "#47383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0762 15.5352V15.6558L37.4486 15.7765L37.0762 15.5352Z",
    fill: "#362B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5654 15.5352V15.6558H45.0206L43.1585 15.5352H38.5654Z",
    fill: "#314139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0215 15.5352V15.6558L45.2698 15.8972H45.3939L45.0215 15.5352Z",
    fill: "#25272F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 15.6543V15.775H21.3096L19.5716 15.6543H14.9785Z",
    fill: "#818163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9238 15.6543V15.775H25.4066L22.9238 15.6543Z",
    fill: "#5F8966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4072 15.6545V15.7752H29.2555C28.5577 15.2818 26.3227 15.6545 25.4072 15.6545Z",
    fill: "#597D62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7451 15.6543V15.775H37.0762L35.3382 15.6543H30.7451Z",
    fill: "#815B5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6895 15.6543V15.775H45.0205L43.2826 15.6543H38.6895Z",
    fill: "#597D62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8545 22.0513H14.9786V15.8961H21.3097L19.9441 15.7754H16.3441L14.9166 15.9162L14.8545 17.5857V22.0513Z",
    fill: "#C7C78A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7999 15.7754L22.6758 17.8271V22.0513H22.7999V17.5857V15.7754Z",
    fill: "#74AA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9238 15.7754V15.8961H29.2549V22.0513L29.379 20.7237V17.2237L29.2341 15.8357L27.5169 15.7754H22.9238Z",
    fill: "#87C78A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6211 22.1719H30.7452V15.8961H37.0763L35.7107 15.7754H32.1107L30.6832 15.9162L30.6211 17.5857V22.1719Z",
    fill: "#C58689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0762 15.7754C37.6364 17.657 37.2003 20.2069 37.2003 22.1719H30.7451V22.2926H35.4624L37.1796 22.2323L37.3244 20.7237V17.103L37.0762 15.7754Z",
    fill: "#AE777B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1924 15.7754V20.8444L38.3373 22.4737L40.1786 22.534H45.1441V22.4133H38.3165V17.5857L38.1924 15.7754Z",
    fill: "#25272F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6895 15.775V15.8957H43.1584C42.367 15.3361 39.7267 15.775 38.6895 15.775Z",
    fill: "#87C78A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1592 15.7754V15.8961H45.0212V19.8788L45.1454 16.7409L45.0005 15.8357L43.1592 15.7754Z",
    fill: "#7CB780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6074 15.8965V22.1723H14.7316V17.7068L14.6074 15.8965Z",
    fill: "#3C423A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7305 15.8965V22.0517H14.8546V17.5861L14.7305 15.8965Z",
    fill: "#818163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 15.8965V22.0517H21.3096V15.8965H14.9785Z",
    fill: "#FEFEAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3095 15.8965V22.0517H14.9785V22.1723H19.5716L21.2889 22.112L21.4337 20.7241V17.2241L21.3095 15.8965Z",
    fill: "#EAEA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4337 15.8965V22.1723H14.9785V22.293H19.6958L21.413 22.2327L21.5578 20.7241V17.2241L21.4337 15.8965Z",
    fill: "#A9A97A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5586 15.8965V22.0517H21.6827V17.5861L21.5586 15.8965Z",
    fill: "#77775A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6836 15.8965V22.293H21.8077V17.7068L21.6836 15.8965Z",
    fill: "#362B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5518 15.8965V22.1723H22.6759V17.7068L22.5518 15.8965Z",
    fill: "#4A6752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7998 15.8965V20.6034L22.9446 22.112L24.6619 22.1723H29.255V22.0517H22.9239V17.5861L22.7998 15.8965Z",
    fill: "#9BE79D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9238 15.8965V22.0517H29.2549V15.8965H22.9238Z",
    fill: "#AAFEAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.379 15.8965C29.379 17.8616 29.8151 20.4114 29.2549 22.293H29.379C29.9215 21.0404 29.5032 18.8428 29.5032 17.4654C29.5032 17.0054 29.639 16.2439 29.379 15.8965Z",
    fill: "#5F8966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5029 15.8965V22.1723H29.6271V17.7068L29.5029 15.8965Z",
    fill: "#394B44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.373 15.8965V22.1723H30.4972V17.7068L30.373 15.8965Z",
    fill: "#47383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4971 15.8965V22.0517H30.6212V17.5861L30.4971 15.8965Z",
    fill: "#875F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7451 15.8965V22.0517H37.0762V15.8965H30.7451Z",
    fill: "#FDAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0762 15.8965V22.0517H30.7451V22.1723H37.2003V17.7068L37.0762 15.8965Z",
    fill: "#E2999A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3242 15.8965V22.0517H37.4484V17.5861L37.3242 15.8965Z",
    fill: "#6A4C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4482 15.8965V22.293H37.5724V17.7068L37.4482 15.8965Z",
    fill: "#25272F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3164 15.8965V22.1723H38.4405V17.7068L38.3164 15.8965Z",
    fill: "#4A6752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4414 15.8965V22.0517H38.5655V17.5861L38.4414 15.8965Z",
    fill: "#74AA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5654 15.8965V20.6034L38.7103 22.112L40.4275 22.1723H45.0206V22.0517H38.6896V17.5861L38.5654 15.8965Z",
    fill: "#9BE79D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6895 15.8965V22.0517H45.0205V15.8965H38.6895Z",
    fill: "#AAFEAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1455 15.8965V22.0517H45.2696V17.5861L45.1455 15.8965Z",
    fill: "#597D62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2695 15.8965V22.1723H45.3937V17.7068L45.2695 15.8965Z",
    fill: "#314139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9727 16.6207V16.7414H20.4416C19.6502 16.1818 17.0099 16.6207 15.9727 16.6207Z",
    fill: "#B6B680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.793 16.6211V16.7418H28.3861V21.2073L28.5102 17.7073L28.3653 16.6814L27.1447 16.6211H23.793Z",
    fill: "#7CB780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6133 16.6211V16.7418H36.3305L34.965 16.6211H31.6133Z",
    fill: "#C58689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5586 16.6207V16.7414H44.0276C43.2362 16.1818 40.5959 16.6207 39.5586 16.6207Z",
    fill: "#7CB780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8486 21.2077H15.9728V16.8629H20.4417L16.9659 16.7422L15.9107 16.883L15.8486 18.0698V21.2077Z",
    fill: "#5D5D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5654 16.7422V21.2077H20.6896C20.6896 20.1756 21.1546 17.5298 20.5654 16.7422Z",
    fill: "#DADA95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5451 16.7422C23.5451 18.0884 23.1391 20.2248 23.6693 21.4491H23.7934L23.5451 16.7422Z",
    fill: "#9BE79D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.793 16.7417V16.8624H28.3861C27.5759 16.2896 24.8546 16.7417 23.793 16.7417Z",
    fill: "#4A6752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4893 16.7422V21.2077H31.6134C31.6134 20.1756 32.0784 17.5298 31.4893 16.7422Z",
    fill: "#AE777B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6133 21.2077H31.7374V16.8629H36.2064L32.7305 16.7422L31.6754 16.883L31.6133 18.0698V21.2077Z",
    fill: "#5A424A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.207 16.7422V21.2077H36.3312C36.3312 20.1756 36.7962 17.5298 36.207 16.7422Z",
    fill: "#875F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3306 16.7422V21.3284H31.4893V21.4491H34.9651L36.3099 21.3887L36.4548 20.3629L36.3306 16.7422Z",
    fill: "#E2999A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3105 16.7422V21.2077H39.4347C39.4347 20.1756 39.8997 17.5298 39.3105 16.7422Z",
    fill: "#93DA94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5586 16.7422V16.8629H44.0276V21.2077L44.1517 17.8284L44.0068 16.8025L42.7862 16.7422H39.5586Z",
    fill: "#394B44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7246 16.8613V21.2062H15.8487C15.8487 20.1977 16.3002 17.6307 15.7246 16.8613Z",
    fill: "#B6B680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9727 16.8613V21.2062H20.4416V16.8613H15.9727Z",
    fill: "#4B4B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4416 16.8613V21.2062H15.9727V21.3268H19.2002L20.4209 21.2665L20.5658 20.2406L20.4416 16.8613Z",
    fill: "#7C7C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6699 16.8613V21.2062H23.7941C23.7941 20.1977 24.2455 17.6307 23.6699 16.8613Z",
    fill: "#5F8966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.793 16.8613V21.2062H28.3861V16.8613H23.793Z",
    fill: "#394B44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7383 16.8613V21.2062H36.2072V16.8613H31.7383Z",
    fill: "#47383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4346 16.8613V20.1199L39.5794 21.2665L40.8001 21.3268H44.0277V21.2062H39.5587C39.5587 20.1977 40.0102 17.6307 39.4346 16.8613Z",
    fill: "#54785B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5586 16.8613V21.2062H44.0276V16.8613H39.5586Z",
    fill: "#314139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1514 16.8613V21.2062H44.2755C44.2755 20.1977 44.727 17.6307 44.1514 16.8613Z",
    fill: "#7CB780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0215 19.8789V22.0513H45.1456L45.0215 19.8789Z",
    fill: "#87C78A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.793 21.2066V21.3273H28.2619C27.4706 20.7678 24.8303 21.2066 23.793 21.2066Z",
    fill: "#597D62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7383 21.207V21.3277H32.359L31.7383 21.207Z",
    fill: "#7B5761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3594 21.2072V21.3279H36.2077C35.5099 20.8345 33.2749 21.2072 32.3594 21.2072Z",
    fill: "#7B575E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8486 21.3277V21.4483H20.4417C19.6316 20.8755 16.9103 21.3277 15.8486 21.3277Z",
    fill: "#DADA95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.793 21.3277V21.4483H28.3861C27.5759 20.8755 24.8546 21.3277 23.793 21.3277Z",
    fill: "#93DA94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5586 21.3277V21.4483H44.1517C43.3416 20.8755 40.6202 21.3277 39.5586 21.3277Z",
    fill: "#93DA94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9238 22.1719V22.2926H27.8893L26.5238 22.1719H22.9238Z",
    fill: "#7CB780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8896 22.1719V22.2926H29.2552L27.8896 22.1719Z",
    fill: "#74AA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6895 22.1719V22.2926H45.0205L43.2826 22.1719H38.6895Z",
    fill: "#74AA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6074 22.2922L14.9798 22.5336V22.4129L14.6074 22.2922Z",
    fill: "#25272F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 22.293V22.4137H17.3371L14.9785 22.293Z",
    fill: "#6B6B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3379 22.293V22.4137H21.3103C20.5938 21.9071 18.2777 22.293 17.3379 22.293Z",
    fill: "#77775A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9238 22.293V22.4137H29.2549L27.5169 22.293H22.9238Z",
    fill: "#54785B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7451 22.293V22.4137H37.2003L35.3382 22.293H30.7451Z",
    fill: "#6A4C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5654 22.293V22.4137H45.0206L43.1585 22.293H38.5654Z",
    fill: "#4A6752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 22.4141V22.5348H21.5578L19.6958 22.4141H14.9785ZM22.7992 22.4141V22.5348H29.2544L27.3923 22.4141H22.7992ZM30.744 22.4141V22.5348H37.0751L35.3371 22.4141H30.744Z",
    fill: "#362B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9238 23.1387V23.2594H29.2549L27.5169 23.1387H22.9238Z",
    fill: "#362B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 23.2578V23.3785H21.4337L19.5716 23.2578H14.9785Z",
    fill: "#4A6752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9238 23.2578V23.3785H29.2549L27.5169 23.2578H22.9238Z",
    fill: "#6B6B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7451 23.2578V23.3785H35.4624L37.1796 23.5193L37.3244 25.1888V29.7751L37.4486 28.3268V24.8268L37.2003 23.3182L35.3382 23.2578H30.7451Z",
    fill: "#4A6752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8545 23.4995V23.6202C16.7551 23.0853 19.3249 23.4995 21.3097 23.4995C20.9523 23.2468 20.1691 23.3788 19.6959 23.3788C18.3116 23.3788 16.1134 22.9842 14.8545 23.4995Z",
    fill: "#74AA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6758 29.7755H22.7999V23.4996H29.2551L27.8896 23.3789H24.2896L22.7379 23.5197L22.6758 25.1893V29.7755Z",
    fill: "#A9A97A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7451 23.3789V23.4996H37.0762L35.3382 23.3789H30.7451Z",
    fill: "#74AA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4482 23.3789V29.8961H37.5724V25.1893L37.4482 23.3789Z",
    fill: "#25272F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6074 23.5V29.8966H14.7316V25.3103L14.6074 23.5Z",
    fill: "#314139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 23.5V23.6207H21.3095V29.7759L21.4337 28.4483V24.9483L21.2889 23.5603L19.5716 23.5H14.9785Z",
    fill: "#9BE79D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6836 23.5V29.7759H21.8077V25.3103L21.6836 23.5Z",
    fill: "#362B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7998 29.7759H22.9239V23.6207H29.255L27.8895 23.5H24.2895L22.8619 23.6408L22.7998 25.3103V29.7759Z",
    fill: "#EAEA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5029 23.5V29.7759H29.6271V25.3103L29.5029 23.5Z",
    fill: "#4B4B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.373 23.5V29.7759H30.4972V25.3103L30.373 23.5Z",
    fill: "#394B44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7451 23.5V23.6207H37.0762V29.7759L37.2003 28.4483V24.9483L37.0554 23.5603L35.3382 23.5H30.7451Z",
    fill: "#9BE79D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7305 23.6211V29.7763H14.8546V25.3107L14.7305 23.6211Z",
    fill: "#597D62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8545 23.6211V28.328L14.9993 29.8366L16.7166 29.897H21.3097V29.7763H14.9786V25.3107L14.8545 23.6211Z",
    fill: "#87C78A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 23.6211V29.7763H21.3096V23.6211H14.9785Z",
    fill: "#AAFEAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4346 23.6211V29.7763H21.5587V25.3107L21.4346 23.6211Z",
    fill: "#74AA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5586 23.6211V29.7763H21.6827V25.3107L21.5586 23.6211Z",
    fill: "#54785B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4277 23.6211V26.397H22.5519L22.4277 23.6211Z",
    fill: "#362B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5518 23.6211V29.7763H22.6759V25.3107L22.5518 23.6211Z",
    fill: "#6B6B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9238 23.6211V29.7763H29.2549V23.6211H22.9238Z",
    fill: "#FEFEAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2549 23.6211V29.7763H22.9238V29.897H27.5169L29.2341 29.8366L29.379 28.4487V24.9487L29.2549 23.6211Z",
    fill: "#C7C78A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3789 23.6211V29.7763H29.503V25.3107L29.3789 23.6211Z",
    fill: "#888868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4971 23.6211V29.7763H30.6212V25.3107L30.4971 23.6211Z",
    fill: "#5F8966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6211 23.6211V28.328L30.766 29.8366L32.4832 29.897H37.0763V29.7763H30.7452V25.3107L30.6211 23.6211Z",
    fill: "#87C78A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7451 23.6211V29.7763H37.0762V23.6211H30.7451Z",
    fill: "#AAFEAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2002 23.6211V29.7763H37.3243V25.3107L37.2002 23.6211Z",
    fill: "#74AA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8486 24.2246V24.3453L20.69 24.466L19.3245 24.2246H15.8486Z",
    fill: "#9BE79D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5449 28.9315H23.6691V24.3453H28.3863L24.6622 24.2246L23.607 24.3654L23.5449 25.6729V28.9315Z",
    fill: "#EAEA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6133 24.2246V24.3453H36.3305V28.9315L36.4547 25.3108L36.3098 24.285L34.965 24.2246H31.6133Z",
    fill: "#9BE79D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9727 24.3453V24.466H20.4416C19.6502 23.9064 17.0099 24.3453 15.9727 24.3453Z",
    fill: "#5F8966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6699 28.9319H23.7941V24.4664H28.3872L24.7872 24.3457L23.732 24.4865L23.6699 25.6733V28.9319Z",
    fill: "#888868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6133 24.3457V24.4664H36.2064V28.9319L36.3305 25.4319L36.1857 24.406L34.965 24.3457H31.6133Z",
    fill: "#5F8966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7243 24.4648C15.7243 25.7795 15.3307 27.8555 15.8484 29.0511H15.9726L15.7243 24.4648Z",
    fill: "#7CB780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8486 24.4648V28.9304H15.9728C15.9728 27.8982 16.4378 25.2525 15.8486 24.4648Z",
    fill: "#4A6752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9727 24.4648V28.9304H20.4416V24.4648H15.9727Z",
    fill: "#394B44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4414 24.4648V28.9304H20.5655C20.5655 27.8982 21.0306 25.2525 20.4414 24.4648Z",
    fill: "#597D62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5654 24.4648V28.9304H20.6896C20.6896 27.8982 21.1546 25.2525 20.5654 24.4648Z",
    fill: "#93DA94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.793 24.4648V28.8097H28.2619V24.4648H23.793Z",
    fill: "#4B4B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2619 24.4648V28.8097H23.793V28.9304H27.0206L28.2412 28.87L28.3861 27.8442L28.2619 24.4648Z",
    fill: "#555547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3861 24.4648V28.9304H23.793V29.0511H27.1447L28.3653 28.9907L28.5102 27.9648L28.3861 24.4648Z",
    fill: "#B6B680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4893 24.4648V27.8442L31.6341 28.9907L34.3444 29.0511V28.9304H31.6134C31.6134 27.8982 32.0784 25.2525 31.4893 24.4648Z",
    fill: "#7CB780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6133 24.4648V27.7235L31.7582 28.87L32.9788 28.9304H36.2064V24.4648H31.6133Z",
    fill: "#394B44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9727 28.9316V29.0523H18.4554L15.9727 28.9316Z",
    fill: "#74AA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4551 28.9316V29.0523H20.4413L18.4551 28.9316Z",
    fill: "#7CB780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3457 28.9316V29.0523H36.2078L34.3457 28.9316Z",
    fill: "#74AA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6074 29.8965V30.1379H14.8557L14.6074 29.8965Z",
    fill: "#25272F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 29.8965V30.0172H21.3096L19.5716 29.8965H14.9785Z",
    fill: "#5F8966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9238 29.8965V30.0172H29.2549L27.5169 29.8965H22.9238Z",
    fill: "#888868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7451 29.8965V30.0172H37.0762L35.3382 29.8965H30.7451Z",
    fill: "#5F8966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3235 29.8965L37.0752 30.0172V30.1379L37.3235 29.8965Z",
    fill: "#314139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 30.0176V30.1383H21.4337L19.5716 30.0176H14.9785Z",
    fill: "#394B44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7998 30.0176V30.1383H29.255L27.3929 30.0176H22.7998Z",
    fill: "#4B4B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7451 30.0176V30.1383H37.0762L35.3382 30.0176H30.7451Z",
    fill: "#394B44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 30.8613V30.982H21.4337L19.5716 30.8613H14.9785Z",
    fill: "#47383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5586 30.8613L21.6827 31.2234H21.8069L21.5586 30.8613ZM22.4276 30.8613V37.4993H22.5517C22.5517 35.4633 22.0955 32.8106 22.6758 30.8613H22.4276Z",
    fill: "#25272F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7998 30.8613V30.982H29.255L27.3929 30.8613H22.7998Z",
    fill: "#394B44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8545 31.103V31.2237C16.7551 30.6888 19.3249 31.103 21.3097 31.103C20.9523 30.8503 20.1691 30.9823 19.6959 30.9823C18.3116 30.9823 16.1134 30.5877 14.8545 31.103Z",
    fill: "#875F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9238 30.9824V31.1031H29.2549L27.5169 30.9824H22.9238Z",
    fill: "#5F8966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8545 37.3794H14.9786V31.2242H21.4338L20.0683 31.1035H16.4683L14.9166 31.2444L14.8545 32.9139V37.3794Z",
    fill: "#C58689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9238 31.1035V31.2242H29.2549V37.3794L29.379 36.0518V32.5518L29.2341 31.1639L27.5169 31.1035H22.9238Z",
    fill: "#87C78A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6074 31.2246V33.397H14.7316L14.6074 31.2246Z",
    fill: "#47383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7305 31.2246V37.3798H14.8546V32.9143L14.7305 31.2246Z",
    fill: "#815B5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 31.2246V37.3798H21.3096V31.2246H14.9785Z",
    fill: "#FDAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3095 31.2246V37.3798H14.9785V37.5005H21.4337V33.035L21.3095 31.2246Z",
    fill: "#E2999A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4346 31.2246V37.5005H21.5587V33.035L21.4346 31.2246Z",
    fill: "#AE777B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5587 31.2246C21.5587 33.1897 21.9948 35.7395 21.4346 37.6212H21.5587C22.1012 36.3685 21.6828 34.1709 21.6828 32.7936C21.6828 32.3335 21.8186 31.5721 21.5587 31.2246Z",
    fill: "#6A4C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6836 31.2246V34.6039H21.8077L21.6836 31.2246Z",
    fill: "#362B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5518 31.2246V35.9315L22.6966 37.601L24.4138 37.7419H29.2552V37.6212H24.4138L22.738 37.3798L22.6759 36.0522V32.6729L22.5518 31.2246Z",
    fill: "#4A6752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6758 31.2246V37.3798H22.7999V32.9143L22.6758 31.2246Z",
    fill: "#74AA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7998 31.2246V35.9315L22.9446 37.4401L24.6619 37.5005H29.255V37.3798H22.9239V32.9143L22.7998 31.2246Z",
    fill: "#9BE79D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9238 31.2246V37.3798H29.2549V31.2246H22.9238Z",
    fill: "#AAFEAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3789 31.2246V37.3798H29.503V32.9143L29.3789 31.2246Z",
    fill: "#5F8966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5029 31.2246V37.3798H29.6271V32.9143L29.5029 31.2246Z",
    fill: "#394B44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8486 31.9487V32.0694H20.4417C19.6316 31.4966 16.9103 31.9487 15.8486 31.9487Z",
    fill: "#AE777B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5659 31.9473V36.6542H15.8486V36.7749H19.2004L20.5452 36.7145L20.69 35.568L20.5659 31.9473Z",
    fill: "#E2999A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.793 31.9488V32.0695H28.3861V33.3971C28.5717 33.149 28.6835 32.1167 28.2619 31.969C27.0918 31.5587 25.0453 31.9488 23.793 31.9488Z",
    fill: "#7CB780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7246 32.0684V36.6546H15.8487V33.3959L15.7246 32.0684Z",
    fill: "#C58689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8486 32.0684V36.5339H15.9728C15.9728 35.5017 16.4378 32.856 15.8486 32.0684Z",
    fill: "#5A424A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9727 32.0684V36.5339H20.4416V32.189L15.9727 32.0684Z",
    fill: "#47383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9453 32.0684V32.189H20.4419L19.9453 32.0684Z",
    fill: "#5A424A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5449 32.0684V35.5684L23.6898 36.7149L25.0346 36.7753H28.3863V36.6546H23.6691V33.3959L23.5449 32.0684Z",
    fill: "#9BE79D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6699 32.0684V35.4477L23.8148 36.5942L25.0354 36.6546H28.3872V36.5339H23.7941C23.7941 35.5017 24.2591 32.856 23.6699 32.0684Z",
    fill: "#5F8966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.793 32.0684V36.5339H28.3861V33.3959L28.324 32.2092L27.1447 32.0684H23.793Z",
    fill: "#394B44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4414 32.1895V36.5343H20.5655C20.5655 35.5258 21.017 32.9588 20.4414 32.1895Z",
    fill: "#7B575E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6143 32.3105V46.1899H13.7384V36.0519C13.7384 35.1629 14.1214 32.9885 13.6143 32.3105Z",
    fill: "#7F7FBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6074 33.3965V37.4999H14.7316C14.7316 36.5389 15.1558 34.1296 14.6074 33.3965Z",
    fill: "#362B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3857 33.3965V36.5344H28.5099L28.3857 33.3965Z",
    fill: "#74AA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6836 34.6035V37.6208H21.8077L21.6836 34.6035Z",
    fill: "#25272F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9727 36.5352V36.6558H18.2071L15.9727 36.5352Z",
    fill: "#815B5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.207 36.5352V36.6558H20.4415L18.207 36.5352Z",
    fill: "#875F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8545 37.3789V37.4996L16.9648 37.6203H21.3097V37.4996C19.3249 37.4996 16.7551 37.9138 14.8545 37.3789Z",
    fill: "#AE777B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9238 37.5V37.6207H29.2549L27.5169 37.5H22.9238Z",
    fill: "#74AA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 37.6211V37.7418H21.3096L19.5716 37.6211H14.9785Z",
    fill: "#6A4C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9591 37.7418V37.8625H21.435L17.9591 37.7418ZM22.8005 37.7418V37.8625H29.3798L27.5178 37.7418H22.8005ZM14.8557 38.4659V38.5866H21.5591L19.6971 38.4659H14.8557Z",
    fill: "#25272F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 38.5859V38.7066H21.4337L19.5716 38.5859H14.9785Z",
    fill: "#6B6B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 38.707V38.8277H21.4337V45.1036L21.5578 43.776V40.276L21.413 38.7674L19.6958 38.707H14.9785Z",
    fill: "#A9A97A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6836 38.707V45.2243H21.8077V40.5174L21.6836 38.707Z",
    fill: "#25272F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6074 38.8281V45.104H14.7316V40.6385L14.6074 38.8281Z",
    fill: "#3C423A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 38.8281V38.9488H21.3095V45.104L21.4337 43.7764V40.2764L21.2889 38.8885L19.5716 38.8281H14.9785Z",
    fill: "#EAEA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5586 38.8281V45.104H21.6827V40.6385L21.5586 38.8281Z",
    fill: "#6B6B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7305 38.9492V39.794H14.8546L14.7305 38.9492Z",
    fill: "#818163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8545 38.9492V43.6561L14.9993 45.1647L16.7166 45.2251H21.3097V45.1044H14.9786V40.6389L14.8545 38.9492Z",
    fill: "#C7C78A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 38.9492V45.1044H21.3096V38.9492H14.9785Z",
    fill: "#FEFEAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8486 39.5523V39.6729H20.4417C19.6316 39.1001 16.9103 39.5523 15.8486 39.5523Z",
    fill: "#DADA95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9727 39.6719V39.7926H20.4416V44.1374L20.5658 40.7581L20.4209 39.7322L19.2002 39.6719H15.9727Z",
    fill: "#77775A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7305 39.793V45.1033H14.8546V41.2412L14.7305 39.793Z",
    fill: "#7C7C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7246 39.793V44.1378H15.8487C15.8487 43.1293 16.3002 40.5624 15.7246 39.793Z",
    fill: "#B6B680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8486 39.793V43.0516L15.9935 44.1981L17.2142 44.2585H20.4417V44.1378H15.9728C15.9728 43.1293 16.4242 40.5624 15.8486 39.793Z",
    fill: "#555547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9727 39.793V44.1378H20.4416V39.793H15.9727Z",
    fill: "#3C423A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5654 39.793V44.2585H20.6896C20.6896 43.2263 21.1546 40.5806 20.5654 39.793Z",
    fill: "#DADA95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9727 44.2594V44.3801H20.4416C19.6502 43.8205 17.0099 44.2594 15.9727 44.2594Z",
    fill: "#B6B680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 45.2246V45.3453H21.3096L19.5716 45.2246H14.9785Z",
    fill: "#7C7C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785 45.3457V45.4664H21.3096L19.5716 45.3457H14.9785Z",
    fill: "#3C423A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8623 46.3105V46.4312H46.1382L43.7795 46.3105H37.5726H13.8623Z",
    fill: "#7F7FBD"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_38590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1322_38590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 35,
    fill: "white",
    transform: "translate(12 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow63);
export default __webpack_public_path__ + "static/media/row-6-3.4de70f87f5b822aea3722bec1702e7cf.svg";
export { ForwardRef as ReactComponent };